/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".modal-title[_ngcontent-%COMP%]{font-size:20px;color:#212529;margin-left:15px;margin-top:5px}.mat-date-range-input[_ngcontent-%COMP%]{display:block;width:140%}.form-control[_ngcontent-%COMP%]{margin-left:15px;width:145px}input[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:focus{outline-offset:-15px}.closeMdl[_ngcontent-%COMP%]{font-size:17px!important;padding:6px 10px!important;margin-top:10px;position:relative;margin-left:40%!important}.modal-header[_ngcontent-%COMP%]{padding-bottom:10px}"];
export { styles as styles };

